import { render, staticRenderFns } from "./ChangePriceProductSets.vue?vue&type=template&id=02f2d707&scoped=true"
import script from "./ChangePriceProductSets.vue?vue&type=script&lang=js"
export * from "./ChangePriceProductSets.vue?vue&type=script&lang=js"
import style0 from "./ChangePriceProductSets.vue?vue&type=style&index=0&id=02f2d707&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f2d707",
  null
  
)

export default component.exports